import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import TariffCoaMappingContMain from "presentation/view/container/TariffCoaMapping/TariffCoaMappingContMain";

CommonEntrypoint(<TariffCoaMappingContMain/>)